import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
import { clientQuery } from 'Core/data/GraphQLApi';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    data: null,
    error: false,
    account: null,

    type: null,
    entity: [],
};


const route = "accounts/views/components/syncEntities/redux/slice";

export const syncEntities = createAsyncThunk("accounts/views/components/syncEntities/redux/slice/syncEntities", async (payload, { rejectWithValue, dispatch }) => {

    try {
        const { companyId, entities } = payload;
        let QUERY = `
            mutation synchronizeEntities ($companyId: Int!, $entities: [SyncEntityInput]) {
                result: synchronizeEntities (companyId: $companyId, entities: $entities){
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate
                }
            }
        `;

        let data = await clientMutation(
            QUERY,
            {
                companyId: companyId,
                entities: entities
            },
            endpoints.GRAPHQL_GENERAL
        );

        return data?.result;

    } catch (exc) {
        // ALWAYS RETURN ACTION
        ExceptionManager(exc, route, 'saveVidfleetConfigurationPreview');
        return rejectWithValue(exc);
    }
}
)

export const getAccounts = async (input = '') => {
    try {
        let QUERY = `
        query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
            result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                    status
                }
            }
        }`
        return await clientQuery(QUERY, {
            conditions: {
                fields: [
                    "name"
                ],
                terms: [
                    input
                ],
                exact: false
            },
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/activities/.components/tab/redux/saga', 'getAccounts');
    }
}


export const syncEntitiesRedux = createSlice({
    name: 'accounts/views/components/syncEntities',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalSyncEntities(state, action) {
            state.openModal = true
            state.account = action.payload?.account
        },
        syncEntitiesSetEntity(state, action) {
            state.type = action.payload?.type
            state.entity = action.payload?.entity
        }

    },
    extraReducers: (builder) => {
        builder.addCase(syncEntities.pending, (state, action) => {
            state.loading = true
        });

        builder.addCase(syncEntities.fulfilled, (state, action) => {
            state.result = action.payload
            state.loading = false;
        });

        builder.addCase(syncEntities.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
        });
    }
})

const { actions, reducer } = syncEntitiesRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalSyncEntities,
    syncEntitiesSetEntity
} = actions;

export default reducer;
